import { render } from "./KnowledgeCardMini.vue?vue&type=template&id=e8c65430&scoped=true"
import script from "./KnowledgeCardMini.vue?vue&type=script&lang=js"
export * from "./KnowledgeCardMini.vue?vue&type=script&lang=js"

import "./KnowledgeCardMini.vue?vue&type=style&index=0&id=e8c65430&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e8c65430"]])

export default __exports__